import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * TIPOS DE CHEQUE: los de fábrica (con texto en i18n) + los que la oficina agrega en Settings →
 * Payments (Manuel 2026-10-02: "Mitigación o algún otro cuando se necesite"). Una sola lista para
 * los dos selects del claim; la lista propia se pide una vez por sesión.
 */
export type CheckTypeOption = { value: string; label: string; builtin: boolean };
export const BUILTIN_CHECK_TYPES: ReadonlyArray<{ value: string; labelKey: string }> = [
  { value: 'acv', labelKey: 'chk.typeAcv' }, { value: 'repairs', labelKey: 'chk.typeRepairs' }, { value: 'supplements', labelKey: 'chk.typeSupplements' },
  { value: 'depreciation', labelKey: 'chk.typeDepreciation' }, { value: 'bc', labelKey: 'chk.typeBc' },
];
type Custom = { value: string; label: string };
let cache: Promise<Custom[]> | null = null;
export const cargarTiposPropios = (fresco = false): Promise<Custom[]> => {
  if (fresco || !cache) cache = api.get<{ types: Custom[] }>('/api/checks/types').then((r) => r.types).catch(() => { cache = null; return []; });
  return cache;
};

/** Lista completa para un <select>: fábrica (traducida) + propios. Si el cheque tiene un valor que ya no existe, se agrega para no perderlo. */
export function useCheckTypes(t: (k: string) => string, extra?: string | null): CheckTypeOption[] {
  const [propios, setPropios] = useState<Custom[]>([]);
  useEffect(() => { let vivo = true; void cargarTiposPropios().then((p) => { if (vivo) setPropios(p); }); return () => { vivo = false; }; }, []);
  const lista: CheckTypeOption[] = [
    ...BUILTIN_CHECK_TYPES.map((b) => ({ value: b.value, label: t(b.labelKey), builtin: true })),
    ...propios.map((p) => ({ value: p.value, label: p.label, builtin: false })),
  ];
  if (extra && !lista.some((x) => x.value === extra)) lista.push({ value: extra, label: extra, builtin: false });
  return lista;
}
